import { api } from '../../../lib/api'

export const GET_STATISTICS_BY_STORY_REQUEST = 'GET_STATISTICS_BY_STORY_REQUEST'
export const GET_STATISTICS_BY_STORY_SUCCESS = 'GET_STATISTICS_BY_STORY_SUCCESS'
export const GET_STATISTICS_BY_STORY_FAILED = 'GET_STATISTICS_BY_STORY_FAILED'

export const getStatisticsByStory = function (storyId) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_STORY_REQUEST
    })
    api.getStatisticsByStory(storyId).then(getStatisticsByStoryResponse => {
      dispatch({
        type: GET_STATISTICS_BY_STORY_SUCCESS,
        payload: getStatisticsByStoryResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_STATISTICS_BY_STORY_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/statistics/get-story-statistics.js